var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FieldBox',{staticClass:"profit-price",attrs:{"title":_vm.title}},[_c('PlusMinusInput',{attrs:{"precision":_vm.precision,"min":0,"max":999999999,"step":_vm.minTick,"match-tick":true,"match-precision":true},model:{value:(_vm.profitTakerPrice),callback:function ($$v) {_vm.profitTakerPrice=$$v},expression:"profitTakerPrice"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }